import { appColors, BackrsIcon } from '@backrs_ui/common-ui';

import { Select, MenuItem, Typography, Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

type SelectMenuProps = Readonly<{
  value: string;
  onChange: (value: string) => void;
  title: string;
  options: { value: string; label: string }[];
}>;

export const SelectMenu = ({ value, onChange, title, options }: SelectMenuProps) => {
  return (
    <Select
      value={value}
      onChange={(event) => onChange(event.target.value as string)}
      displayEmpty
      IconComponent={(props) => (
        <Box {...props} sx={iconContainer}>
          <BackrsIcon name="IconDropdown" alt="Dropdown" />
        </Box>
      )}
      renderValue={() => <Typography sx={menuTitle}>{title}</Typography>}
      sx={menuStyles}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

const iconContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as const;

const menuStyles: SxProps<Theme> = {
  height: '20px',
  borderRadius: '8px',
  backgroundColor: appColors.color.blue4,
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSelect-select': {
    paddingRight: '32px !important',
    width: 'auto',
  },
  '& .MuiSelect-icon': {
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    position: 'absolute',
  },
  '@media (max-width: 700px)': {
    minWidth: '250px',
  },
};

const menuTitle: React.CSSProperties = {
  fontSize: '10.5pt',
  fontWeight: '500',
};
